import { createPluginFactory } from '@udecode/plate';

import { withMultiCol } from './withMultiCol';

export const ELEMENT_MULTI_COL = 'multi_col';

export const createMultiColPlugin = createPluginFactory({
  key: ELEMENT_MULTI_COL,
  isElement: true,
  withOverrides: withMultiCol,
});
